<div class="container-center">
  <svg xmlns="http://www.w3.org/2000/svg" width="77" height="71" viewBox="0 0 77 71" fill="none">
    <g opacity="0.6">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.636963 33.1316C0.636963 14.3583 18.1054 0.00390625 38.5 0.00390625C58.8946 0.00390625 76.363 14.3583 76.363 33.1316C76.363 51.905 58.8946 66.2593 38.5 66.2593C36.1175 66.2593 33.735 66.0715 31.3821 65.676C25.9844 69.5612 19.3905 71.4099 12.7571 70.9156C12.1441 70.876 11.5609 70.6684 11.0468 70.3323C10.5328 69.9962 10.1274 69.5315 9.85061 68.9878C9.5738 68.4441 9.43542 67.841 9.46508 67.2281C9.49473 66.6152 9.67268 66.022 9.98903 65.508C11.5411 63.0068 12.3913 60.1399 12.4605 57.1939C5.26356 51.2327 0.636963 42.7111 0.636963 33.1316Z"
        fill="#CCCDCE"
      />
      <path
        d="M38.5001 55.4552C53.7877 55.4552 66.1807 45.8594 66.1807 34.0225C66.1807 22.1856 53.7877 12.5898 38.5001 12.5898C23.2126 12.5898 10.8196 22.1856 10.8196 34.0225C10.8196 45.8594 23.2126 55.4552 38.5001 55.4552Z"
        fill="white"
      />
      <path
        d="M29.5828 27.418C31.8664 27.418 33.7151 29.2666 33.7151 31.5503V37.0271C33.7151 39.3107 31.8664 41.1594 29.5828 41.1594C27.2991 41.1594 25.4504 39.3107 25.4504 37.0271V31.5503C25.4504 29.2666 27.2991 27.418 29.5828 27.418Z"
        fill="#CCCDCE"
      />
      <path
        d="M48.1887 27.418C50.4723 27.418 52.321 29.2666 52.321 31.5503V37.0271C52.321 39.3107 50.4723 41.1594 48.1887 41.1594C45.9051 41.1594 44.0564 39.3107 44.0564 37.0271V31.5503C44.0564 29.2666 45.9051 27.418 48.1887 27.418Z"
        fill="#CCCDCE"
      />
    </g>
  </svg>
  <h1 class="mt-5 font-bold">Este módulo no está disponible en tu plan actual</h1>
  <p>Suscríbete y desbloquea el acceso total a Globot</p>
  <button class="btn" (click)="showPlansDialog = true">Suscribirse ahora</button>
</div>
<p-dialog
  header="Planes de suscripción"
  [modal]="true"
  [style]="{ width: '70rem' }"
  [(visible)]="showPlansDialog"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [resizable]="false"
>
  <globot-type-subscription-plans></globot-type-subscription-plans>
</p-dialog>
